import { AxiosRequestConfig } from "axios";
import Api, { IPagination } from "utils/http-common";

export interface IReponse<T=any>{
  data:T;
  pagination:IPagination;
}


export interface IPropsConfig extends AxiosRequestConfig<any>{}
export interface IService{
  path: string;
  api: Api;
  getPaginated:<T=any>(params?: any)=>Promise<IReponse<T>>;
  get:<T=any>(params?: any)=>Promise<T>;
  store:(<T=any>(params: any, config?:IPropsConfig)=>Promise<T>);
  show:<T=any>(id:number|string, params?:any)=>Promise<T>;
  update:<T=any>(id:number|string, params:any)=>Promise<T>;
  [x: string]: any;
}

function setLoadRequest(v:boolean){
  let element = document.getElementById("load-request");
  let masterpage = document.getElementById("masterpage");
  if(element != null)
    element.style.display = v?"block":"none";
  
  if(masterpage != null)
    masterpage.style.overflow = v?"hidden":"";
}

function setLoadRequestOk(v:boolean){
  let load = document.getElementById("lds-ellipsis");
  let correct = document.getElementById("correct-icon");
  if(load != null)
    load.style.display = v?"none":"";
  
  if(correct != null)
    correct.style.display = v?"":"none";
}

export class CService implements IService {
  path: string;
  api: Api;
  constructor(path:string){
    this.path = path;
    this.api = new Api();
  }
  getPaginated<T = any>(params?: any):Promise<IReponse<T>>{
    return this.api.get<any, IReponse<T>>(`/${this.path}/paginated`,params);
  };
  get<T = any>(params?: any):Promise<T>{
    return this.api.get<any, T>(`/${this.path}`,params);
  };
  store<T = any>(params: any):Promise<T>{
    return this.api.post<any, T>(`/${this.path}`,params);
  };
  storeLoad<T = any>(params: any):Promise<T>{
    return new Promise(async (yes,no)=>{
      setLoadRequest(true);
      setLoadRequestOk(false);
      try {
        let res:T = await this.api.post<any, T>(`/${this.path}`,params);
        yes(res);
        setTimeout(()=>setLoadRequestOk(true),300);
        setTimeout(()=>setLoadRequest(false),2000);
      } catch (error) {
        setLoadRequest(false);
        no(error);
      }
    });
  };
  show<T = any>(id: string | number, params?: any):Promise<T>{
    return this.api.get<any, T>(`/${this.path}/${id}`,params);
  };
  update<T = any>(id: string | number, params: any):Promise<T>{
    return this.api.post<any, T>(`/${this.path}/${id}?_method=PUT`,params);
  };
  updateLoad<T = any>(id: string | number, params: any):Promise<T>{
    return new Promise(async (yes,no)=>{
      setLoadRequest(true);
      setLoadRequestOk(false);
      try {
        let res:T = await this.api.post<any, T>(`/${this.path}/${id}?_method=PUT`,params);
        yes(res);
        setTimeout(()=>setLoadRequestOk(true),300);
        setTimeout(()=>setLoadRequest(false),2000);
      } catch (error) {
        setLoadRequest(false);
        no(error);
      }
    });
  };

}